// Shared client presentation primitives.
//
// The tightened generic `clientRowSchema` (plus its `account*` / segment /
// mandate / service-type / compliance / risk enums) once lived here as a tracer
// for the retired passthrough-row model (ADR-0008) and has been removed — it had
// no consumers. Each view contract now authors its own real `z.object` DTOs at
// the mapping seam (ADR-0018). The only shared primitive that remains is the
// minimal client stub below.

import { z } from 'zod';

// The minimal `{ id, name }` client reference several view contracts attach so
// the page can resolve a clientId to a display name without a second round-trip
// (call-intelligence, fair-value, suitability, desk-pages). One named schema,
// imported by all of them, rather than four anonymous re-declarations.
export const clientStubSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export type ClientStub = z.infer<typeof clientStubSchema>;
